import { useSyncExternalStore } from 'react';

/** Reactive media query. Uses the browser as the store, so there is no state to keep in sync. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => { const mq = matchMedia(query); mq.addEventListener('change', onChange); return () => mq.removeEventListener('change', onChange); },
    () => matchMedia(query).matches,
    () => false, // server/SSR-less default: assume desktop until the browser answers
  );
}

/** Below Tailwind's `md`: phones and small tablets get the bottom tab bar and sheets. */
export const useIsMobile = () => useMediaQuery('(max-width: 767px)');
